import React, { Component } from 'react'
import {Grid } from '@material-ui/core/';

const colors = [
  '#61BD4F',
  '#F2D600',
  '#FF9F1A',
  '#EB5A46',
  '#C377E0',
  '#0079BF'
]

const ColorItem = ({color, colorChange}) => {
  return (
    <div style={{width: '100%', minHeight: 30,backgroundColor: color, borderRadius: '6px'}} onClick={() => colorChange(color)}></div>
  )
}

export default class ColorPresets extends Component {
  
  render() {
    console.log(this.props,"ddddd")
    return (
      <>
        {
          colors.map(c => {
            return (
              <Grid item xs={2}><ColorItem color={c} colorChange={this.props.colorChange}/></Grid>)
          })
        }
      </>
    )
  }
}
